import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Typography,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import axios from "axios";
import DoctorBooking from "./Doctorbooking";
import { Heading } from "../componenet/heading";
const departments = {
  "Cardiology ❤️": ["Dr. Smith", "Dr. Johnson"],
  "Neurology 🧠": ["Dr. Patel", "Dr. Brown"],
  "Orthopedics 🦴": ["Dr. Wilson", "Dr. Lee"],
  "Pediatrics 🧒": ["Dr. White", "Dr. Taylor"],
};

const steps = ["Basic Info", "Personal Info", "Insurance Info", "Medical Info", "Doctor Shedule & Payment"];

const PatientEntryForm = () => {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    title: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    dob: "",
    age_years: "",
    useDob: true, // flag for DOB vs Age
    gender: "",
    phone: "",
    email: "",
    address: "",
    id_doc: "",
    emergency_contact: "",
    blood_group: "",
    allergies: "",
    chronic_conditions: "",
    department: "",
    doctor: "",
  });

  // handle generic change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // handle DOB change with age auto-calc
  const handleDobChange = (e) => {
    const dob = e.target.value;
    setFormData((prev) => ({ ...prev, dob }));

    if (dob) {
      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setFormData((prev) => ({ ...prev, age_years: age.toString() }));
    }
  };

  const handleDobToggle = (e) => {
    const value = e.target.value === "true";
    setFormData((prev) => ({
      ...prev,
      useDob: value,
      dob: value ? prev.dob : "",
      age_years: value ? prev.age_years : "",
    }));
  };

  const handleNext = () => setStep(step + 1);
  const handleBack = () => setStep(step - 1);

  const handleSubmit = async () => {
    try {
      await axios.post("/api/patient", formData);
      alert("✅ Patient Registered Successfully!");
    } catch (error) {
      alert("❌ Failed to Register Patient");
    }
  };


const resetForm = () => {
    setFormData({});
    setStep(0); // ✅ reset stepper
  };



  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: 3,
        borderRadius: 3,
        boxShadow: 3,
       // maxWidth: 800,
        margin: "auto",
        mt: 3,
      }}
    >
    
    


<div>
  <Heading headingtext="✍️ New Patient Registration" />  
</div>






      {/* Stepper */}
      <Stepper activeStep={step} alternativeLabel sx={{ mb: 3 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* Step 1: Basic Info */}
      {step === 0 && (
        <>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <TextField
              select
              fullWidth
              name="title"
              label="👤 Title"
              value={formData.title||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            >
              <MenuItem value="Mr">👨 Mr</MenuItem>
              <MenuItem value="Mrs">👩‍🦰 Mrs</MenuItem>
              <MenuItem value="Ms">👩 Ms</MenuItem>
              <MenuItem value="Other">⚧ Other</MenuItem>
            </TextField>

            <TextField
              fullWidth
              name="first_name"
              label="🧑 First Name"
              value={formData.first_name||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>
            <TextField
              fullWidth
              name="middle_name"
              label="👤 Middle Name"
              value={formData.middle_name||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />
            <TextField
              fullWidth
              name="last_name"
              label="👤 Last Name"
              value={formData.last_name||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />
          </div>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: 10 }}>
            {/* DOB Available Selection */}
            <TextField
              select
              fullWidth
              name="useDob"
              label="📅 DOB Available?"
              value={formData.useDob ||''}
              onChange={handleDobToggle}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            >
              <MenuItem value="true">✅ Yes</MenuItem>
              <MenuItem value="false">❌ No</MenuItem>
            </TextField>

            {/* DOB or Age */}
            {formData.useDob ? (
              <TextField
                fullWidth
                type="date"
                name="dob"
                label="🎂 Date of Birth"
                InputLabelProps={{ shrink: true }}
                value={formData.dob||''}
                onChange={handleDobChange}
                sx={{
                  flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
                }}
              />
            ) : (
              <TextField
                fullWidth
                type="number"
                name="age_years"
                label="🎯 Age"
                value={formData.age_years||''}
                onChange={handleChange}
                sx={{
                  flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
                }}
              />
            )}
          </div>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>
            <TextField
              select
              fullWidth
              name="gender"
              label="⚧ Gender"
              value={formData.gender||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            >
              <MenuItem value="Male">👨 Male</MenuItem>
              <MenuItem value="Female">👩 Female</MenuItem>
              <MenuItem value="Other">⚧ Other</MenuItem>
            </TextField>
            <TextField
              select
              fullWidth
              name="blood_group"
              label="🩸 Blood Group"
              value={formData.blood_group||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            >
              <MenuItem value="NA">❌ Not Available</MenuItem>
              <MenuItem value="A+">🅰️+ </MenuItem>
              <MenuItem value="A-">🅰️- </MenuItem>
              <MenuItem value="B+">🅱️+ </MenuItem>
              <MenuItem value="B-">🅱️- </MenuItem>
              <MenuItem value="AB+">🆎+</MenuItem>
              <MenuItem value="AB-">🆎-</MenuItem>
              <MenuItem value="O+">⭕+ </MenuItem>
              <MenuItem value="O-">⭕- </MenuItem>
            </TextField>
          </div>




         <Box mt={2} display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={handleNext} >
              Next ➡️
            </Button>
          </Box>
        </>
      )}

      {/* Step 2: Personal Info */}
      {step === 1 && (
        <>


          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>
            <TextField
              fullWidth
              name="id_doc"
              label="🪪 ID Document"
              value={formData.id_doc||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />
            <TextField
              fullWidth
              name="emergency_contact"
              label="🚨 Emergency Contact"
              value={formData.emergency_contact||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />
          </div>


          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>


            <TextField
              fullWidth
              name="phone"
              label="📞 Phone"
              value={formData.phone||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />
            <TextField
              fullWidth
              name="email"
              label="📧 Email"
              value={formData.email||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />

          </div>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>


            <TextField
              fullWidth
              name="address"
              label="🏠 Address"
              multiline
              rows={2}
              value={formData.address||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />


          </div>

          <Box mt={2} display="flex" justifyContent="space-between">
            <Button variant="outlined" onClick={handleBack}>
              ⬅️ Back
            </Button>
            <Button variant="contained" onClick={handleNext}>
              Next ➡️
            </Button>
          </Box>
        </>
      )}

      {/* Step 3: Contact Info */}
      {/* {step === 2 && (
        <>
        
          <Box display="flex" justifyContent="space-between">
            <Button variant="outlined" onClick={handleBack}>
              ⬅️ Back
            </Button>
            <Button variant="contained" onClick={handleNext}>
              Next ➡️
            </Button>
          </Box>
        </>
      )} */}



      {/* Step 4: Insurance Info */}
      {step === 2 && (
        <>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <TextField
              fullWidth
              name="insuranceComp"
              label="🏦 Insurance Company"
              value={formData.insuranceComp||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />
            <TextField
              fullWidth
              name="policynumber"
              label="🔢 Policy Number"
              value={formData.policynumber||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />
            <TextField
              fullWidth
              name="insurancestartdate"
              type="date"
              label="🎂 Insurance Start Date"
              InputLabelProps={{ shrink: true }}
              value={formData.insurancestartdate||''}
              onChange={handleDobToggle}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, mt: 1// 100% on xs, ~50% on small+ screens
              }}
            />

            <TextField
              fullWidth
              name="insuranceenddate"
              type="date"
              label="📅 Insurance Validity Date"
              InputLabelProps={{ shrink: true }}
              value={formData.insuranceenddate||''}
              onChange={handleDobToggle}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }
                , mt: 1// 100% on xs, ~50% on small+ screens
              }}
            />
          </div>



          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>


            <TextField
              fullWidth
              name="insurancecomment"
              label="📜 Comments (if Any)"
              multiline
              rows={3}
              value={formData.insurancecomment||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />


          </div>


          <Box display="flex" justifyContent="space-between" mt={2}>
            <Button variant="outlined" onClick={handleBack}>
              ⬅️ Back
            </Button>
            <Button variant="contained" onClick={handleNext}>
              Next ➡️
            </Button>
          </Box>
        </>
      )}






      {/* Step 5: Medical Info */}
      {step === 3 && (
        <>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>

            <TextField
              fullWidth
              label="📏 Height (cm)"
              name="height"
              value={formData.height||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />

            <TextField
              fullWidth
              label="⚖️ Weight (kg)"
              name="weight"
              value={formData.weight||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}

            />

          </div>


          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>

            <TextField
              fullWidth

              label="💉 Blood Pressure (mmHg)"
              name="bp"
              value={formData.bp||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}

            />
            <TextField
              fullWidth
              label="❤️ Pulse (bpm)"
              name="pulse"
              value={formData.pulse||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}

            />
          </div>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>
            <TextField
              fullWidth
              label="🌡️ Temperature (°C)"
              name="temperature"
              value={formData.temperature||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />



            <TextField
              fullWidth
              name="allergies"
              label="🤧 Allergies"
              value={formData.allergies||''}
              onChange={handleChange}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />


          </div>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "10px" }}>


            <TextField
              fullWidth
              name="chronic_conditions"
              label="🩺 Chronic Conditions"
              value={formData.chronic_conditions||''}
              onChange={handleChange}
              multiline
              rows={2}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 48%" }, // 100% on xs, ~50% on small+ screens
              }}
            />
          </div>

          <Box display="flex" justifyContent="space-between" mt={2}>
            <Button variant="outlined" onClick={handleBack}>
              ⬅️ Back
            </Button>
            <Button variant="contained" onClick={handleNext}>
              Next ➡️
            </Button>
          </Box>
        </>
      )}






      {/* Step 6: Select Doctor , Payemnt & Ssubmition */}
      {step === 4 && (
        <>

         
 <div>
      {step === 4 && (
        <DoctorBooking
          departments={departments}
          onBookingComplete={resetForm} // 🔑 callback
        />
      )}
    </div>




          <Box display="flex" justifyContent="space-between" marginTop={2}>
            <Button variant="outlined" onClick={handleBack}>
              ⬅️ Back
            </Button>
            {/* <Button variant="contained" color="success" onClick={handleSubmit}>
              ✅ Submit
            </Button> */}
          </Box>
        </>
      )}
    </Box>
  );
};

export default PatientEntryForm;
